'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dFeatures$0024 from "./presto.types$-Features$.js";
var $p;
/** @constructor */
function $c_Lpresto_ListEnvelopesPage$() {
}
export { $c_Lpresto_ListEnvelopesPage$ as $c_Lpresto_ListEnvelopesPage$ };
$p = $c_Lpresto_ListEnvelopesPage$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_ListEnvelopesPage$;
/** @constructor */
function $h_Lpresto_ListEnvelopesPage$() {
}
export { $h_Lpresto_ListEnvelopesPage$ as $h_Lpresto_ListEnvelopesPage$ };
$h_Lpresto_ListEnvelopesPage$.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return 912975796;
});
$p.l = (function() {
  return "ListEnvelopesPage";
});
$p.r = (function() {
  return 0;
});
$p.s = (function() {
  return "ListEnvelopesPage";
});
$p.j = (function(n) {
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.dl = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Some($j_presto$002etypes$0024$002dFeatures$0024.$m_Lpresto_types$Features$().xn);
});
var $d_Lpresto_ListEnvelopesPage$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_ListEnvelopesPage$, "presto.ListEnvelopesPage$", ({
  KW: 1,
  a2: 1,
  b: 1,
  c: 1,
  a: 1,
  e: 1,
  g: 1,
  m: 1
}));
export { $d_Lpresto_ListEnvelopesPage$ as $d_Lpresto_ListEnvelopesPage$ };
var $n_Lpresto_ListEnvelopesPage$;
function $m_Lpresto_ListEnvelopesPage$() {
  if ((!$n_Lpresto_ListEnvelopesPage$)) {
    $n_Lpresto_ListEnvelopesPage$ = new $c_Lpresto_ListEnvelopesPage$();
  }
  return $n_Lpresto_ListEnvelopesPage$;
}
export { $m_Lpresto_ListEnvelopesPage$ as $m_Lpresto_ListEnvelopesPage$ };
//# sourceMappingURL=presto.-List-Envelopes-Page$.js.map
